import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { ScoreHistogramBucket } from '@recruitai/shared';

interface ScoreHistogramProps {
  data: ScoreHistogramBucket[];
  title?: string;
  color?: string;
}

export function ScoreHistogram({ data, title, color = '#3b82f6' }: ScoreHistogramProps) {
  return (
    <div className="bg-white rounded-lg border p-4">
      {title && <h3 className="text-sm font-medium text-gray-700 mb-3">{title}</h3>}
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="range" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
          <Tooltip formatter={(value: number) => [value, 'Candidatos']} />
          <Bar dataKey="count" fill={color} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
